import {
    PsHttpService,
    type PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ContentBlock } from '../../types';
import { isUserLogin } from '@eureka/utils/account';

// ==================== Request Types ====================

/**
 * 初始化 Hiro 会话请求参数
 */
export interface InitHiroSessionRequest {
    /** 内容块数组（包含文本和图片） */
    content: ContentBlock[];
}

/**
 * 初始化 Hiro 会话响应
 */
export interface InitHiroSessionResponse {
    /** 问题ID */
    id: string;
}

// ==================== API Interface ====================

export interface HiroApi {
    /**
     * 初始化 Hiro 会话
     */
    initSession(data: InitHiroSessionRequest): Promise<InitHiroSessionResponse>;
}

export const HiroApi = Symbol('HiroApi');

// ==================== API Implementation ====================

async function getBaseURL() {
    const isLogin = await isUserLogin();
    if (isLogin) {
        return `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-search-api/search`;
    } else {
        return `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/free-share/core-search-api/search`;
    }
}

@injectable()
export class HiroApiImpl extends PsHttpService implements HiroApi {
    get options() {
        return {
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async initSession(data: InitHiroSessionRequest) {
        return this.post<PatSnapSuccessResponseData<InitHiroSessionResponse>>({
            url: `${await getBaseURL()}/hiro/init`,
            data,
        }).then((res) => {
            return res.data;
        });
    }
}
